window.__VUE_OPTIONS_API__ = true;
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

import { createApp } from "vue";
import App from "./App.vue";
import "./core.scss";
import "./ext-imports.css";
import store from "./vuex/core";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

createApp(App)
  .use(store)
  .component("VueDatePicker", VueDatePicker)
  .mount("#cnc-wp-vue");
